import { Pipe, PipeTransform } from '@angular/core';


@Pipe({
  name: 'arrayToString'
})
export class ArrayToStringPipe<T> implements PipeTransform {

  /**
   *
   *  Create string from list of primitive values or Object.
   *  Each item is separated by given separate (comma is the default one).
   *
   * @param value
   * @param separator
   * @param mapFn
   */
  transform(value: T[] | null, separator: string =',', mapFn:(item: T)=> string = ((item)=>item as string)): string {
    return (value && Array.isArray(value)) ? value.reduce((prev, current)=> `${prev} ${mapFn(current)}${separator}`, '').slice(0, -1) : '';
  }

}
